<script lang="ts">
  import { tally } from "../../lib/iterable";
  import RadioGroup from "../RadioGroup.svelte";
  import CropImage from "../CropImage.svelte";
  import type { UnsignedMattersState } from "./UnsignedMattersState.svelte";
  import type { Snippet } from "svelte";

  let {
    manager,
    introduction,
    notice = null,
    ...props
  }: {
    manager: UnsignedMattersState,
    introduction: Snippet<[plural: boolean]>,
    notice?: Snippet,
    props?: Record<string, any>
  } = $props();

  const askMeLaterBtnClass = "btn-secondary";
  const askMeLaterBtnLabel = "Ask me later";
  let plural = $derived((manager.matters?.length || 0) > 1);
  let defaultChoice = $derived(manager.allowIndividualAskLater ? "later" : "yes")
  let choices = $state(
    manager.matters.reduce((memo, matter) => Object.assign(memo, { [matter.sfid]: defaultChoice }), {})
  );
  let choiceTally = $derived(tally(Object.values(choices)));
  let [btnClass, label] = $derived(
    choiceTally.get("yes")
      ? ["btn-primary", "Continue to signature"]
      : choiceTally.get("no")
      ? ["btn-warning", "Do not pursue"]
      : [askMeLaterBtnClass, askMeLaterBtnLabel]
  );

  let choiceRadioOptions: [string, string][] = manager.allowIndividualAskLater ? [["Yes", "yes"], ["No", "no"], ["Ask later", "later"]] : [["Yes", "yes"], ["No", "no"]]

  const onclick = () => manager.answerOffer(choices);
  const onClickAskLater = () => {
    let askLaterChosen = manager.matters.reduce((memo, matter) => Object.assign(memo, { [matter.sfid]: "later" }), {})
    manager.answerOffer(askLaterChosen);
  }
</script>

<div {...props}>
  <h2 class="ui-title mb-3 text-center">
    We found {plural ? "more claims" : "another claim"}<span class="hidden sm:inline">{" for you"}</span>!
  </h2>
  <p class="text-base mb-4">{@render introduction(plural)}</p>
  <p class="text-base font-medium">
    Shall we pursue {plural ? "these claims" : "this claim"} for you?
  </p>
  <div class="-mx-1 -mt-0.5">
    {#each manager.matters as matter (matter.sfid)}
      {@const { sfid, title, image_url, vrm } = matter}
      <div class="text-base font-medium my-3 pt-3 border-t border-solid border-neutral-200 flex gap-2 justify-between items-center px-1">
        <div class="flex flex-col gap-2">
          <div class="leading-tight">{title}</div>
          <RadioGroup
            vertical={false}
            options={choiceRadioOptions}
            name={`choice-${sfid}`}
            bind:group={choices[sfid]}
          />
        </div>
        <div class="flex flex-col items-center">
          {#if image_url}
            <CropImage src={image_url} class="w-28 h-14" />
          {/if}
          {#if vrm}
            <span class="badge badge-ghost badge-xs inline-block whitespace-nowrap overflow-hidden text-nowrap text-ellipsis max-w-full">
              VRM: {vrm}
            </span>
          {/if}
        </div>
      </div>
    {/each}
  </div>
  {@render notice?.()}
  <div class="floating-footer">
    {#if !manager.allowIndividualAskLater}
      <button onclick={onClickAskLater} class={`btn ${askMeLaterBtnClass}`}>{askMeLaterBtnLabel}</button>
    {/if}
    <button {onclick} class={`btn ${btnClass}`}>{label}</button>
  </div>
</div>
